export const supportEmail = 'multiverse@papercut.com'

export interface SupportContact {
  id: string
  name: string
  supportEmail: string
}
